<template>
  <!--  高度可以细微调整，overflow可以使页面滚动 todo 去除:-->
  <div style="height: 100vh;   width: 100vw;
  background-color: #fafafa;
  flex: auto;
  -webkit-flex: auto;
  position: fixed" v-if="show">
    <div class="container" style="position: -webkit-sticky; position: sticky;position: -webkit-sticky">
      <div style="padding: 10px 20px">
        <div class="flex-y-bottom">
          <div class="bo-logo flex-grow-0">
            <img :src="serviceUrl" />
          </div>
          <div class="bo-title flex-grow-1">
            <div>{{information.boSolution.children[0].externalName ? information.boSolution.children[0].externalName : information.boSolution.children[0].name}}</div>
            <div>
              {{information.boSolution.children[0].briefInfoDetail}}
            </div>
          </div>
        </div>
        <div class="flex-row">
          <div class="flex-grow-1">
            <span class="real-price">￥{{emkt.formatPrice(information.boSolution.children[0].formalQuotePrice)}}</span>
            <span class="sale-price"><s>￥{{emkt.formatPrice(information.boSolution.children[0].standardPrice)}}</s></span>
          </div>
          <div class="flex-grow-1 right">
            <span class="deliver-text">预计交付周期：</span>
            <span class="deliver-value">{{information.boSolution.children[0].workdays}}个工作日</span>
          </div>
        </div>
      </div>
    </div>
    <div style="height:80vh; overflow: auto;">
      <div>
        <div class="segment-wrap">
          <span class="group-title">样本信息</span>
          <div class="cell-group-wrap">
            <van-cell>
              <van-row>
                <van-col span="6" class="cell-label">样本物种</van-col>
                <van-col span="18" class="cell-content">{{information.sampleSpec}} {{information.otherTaxName}}</van-col>
              </van-row>
            </van-cell>
            <van-cell>
              <van-row>
                <van-col span="6" class="cell-label">疾病方向</van-col>
                <van-col span="18" class="cell-content">{{information.diseaseDirection.name}}</van-col>
              </van-row>
            </van-cell>
            <van-cell v-if="information.currEu !== specialEuTemplateNo(0)">
              <van-row>
                <van-col span="6" class="cell-label">样本分类</van-col>
                <van-col span="18" class="cell-content">{{information.singleMeteData.sampleCategory.dictValue}}</van-col>
              </van-row>
            </van-cell>
            <van-cell>
              <van-row>
                <van-col span="6" class="cell-label">样本类型</van-col>
                <van-col span="18" class="cell-content">{{information.sampleType}}</van-col>
              </van-row>
            </van-cell>
          </div>
        </div>
        <div class="segment-wrap">
          <span class="group-title">实验分组及样本数</span>
          <div class="cell-group-wrap">
            <van-cell v-for="(experimental, index) in information.boSolution.children[0].groups" :key="experimental.name">
              <van-row>
                <van-col span="6" class="cell-label">{{experimental.name}}</van-col>
                <van-col span="18" class="cell-content">{{experimental.bioRepeatTimes}}</van-col>
              </van-row>
            </van-cell>
            <van-cell v-for="(it, index) in information.controlGroups" :key="index">
              <van-row>
                <van-col span="6" class="cell-label">生信分析组{{index+1}}</van-col>
                <van-col span="18" class="cell-content">{{it[0]}} VS {{it[1]}}</van-col>
              </van-row>
            </van-cell>
          </div>
        </div>
        <div class="segment-wrap" v-if="information.currEu !== specialEuTemplateNo(0)">
          <span class="group-title">其他参数</span>
          <div class="cell-group-wrap">
            <van-cell v-if="information.singleMeteData.paraRemoveHAProtein.dictValue !== '-'">
              <van-row>
                <van-col span="6" class="cell-label">样本处理</van-col>
                <van-col span="18" class="cell-content">{{information.singleMeteData.paraRemoveHAProtein.dictValue}}</van-col>
              </van-row>
            </van-cell>
            <van-cell v-if="information.singleMeteData.paraConstructionTech.dictValue !== '-'">
              <van-row>
                <van-col span="6" class="cell-label">建库技术</van-col>
                <van-col span="18" class="cell-content">{{information.singleMeteData.paraConstructionTech.dictValue}}</van-col>
              </van-row>
            </van-cell>
            <van-cell v-if="information.singleMeteData.paraBioAnalysis.dictValue !== '-'">
              <van-row>
                <van-col span="6" class="cell-label">生信分析</van-col>
                <van-col span="18" class="cell-content">{{information.singleMeteData.paraBioAnalysis.dictValue}}</van-col>
              </van-row>
            </van-cell>
            <div v-if="information.geneSelectionGroup.length > 0">
              <van-cell v-for="(item, index) in information.geneSelectionGroup" :key="index">
                <van-row >
                  <van-col span="6" class="cell-label">基因{{index+1}}</van-col>
                  <van-col span="18" class="cell-content">{{item.outlineInfo}}</van-col>
                </van-row>
              </van-cell>
            </div>
          </div>
        </div>
        <div class="segment-wrap">
          <span class="group-title">质量承诺</span>
          <div class="cell-group-wrap" style=" font-size: 12px; padding: 0 20px"
               v-for="(item, index) in serviceWorkDaysSolution.qualityCommitment" :key="index">
            <div>{{index+1}}、{{item.nameList[0]}}</div>
            <div v-html="item.content"></div>
          </div>
        </div>
        <div class="segment-wrap">
          <span class="group-title">服务说明</span>
          <div class="cell-group-wrap" style=" font-size: 12px; padding: 0 20px"
               v-for="(item, index) in serviceWorkDaysSolution.serviceComments" :key="index" >
            <div>{{index+1}}、{{item.nameList[0]}}</div>
            <div v-html="item.content"></div>
          </div>
        </div>
      </div>
      <!--      我是有底线的，无需修改什么。-->
      <div style="color: #D2D2D6; text-align: center;pointer-events:none;">
        <p style="font-size: 12px; margin-bottom: 50%;">---我是有底线的---</p>
      </div>
    </div>

  </div>
</template>
<script>
/* eslint-disable */
import {mapMutations, mapState, mapGetters} from "vuex";
import Emkt from "../../emkt";
import StaticDoc from "../multiplex/StaticDoc";
import {getSolutionInfoByCartItemData, getSolutionInfoByOrderId, specialEuTemplateNo
} from "../../util/templateToUserData";

export default {
  components: {StaticDoc},
  data() {
    return {
      serviceWorkDaysSolution: null,
      sampleSpecOptArr: [{engName:"Mouse",chnName:"小鼠"}, {engName:"Rat",chnName:"大鼠"}, {engName:"Human",chnName:"人类"}, {engName:"其他",chnName:"其他"}],
      show: false,
      serviceUrl: "/emktResources/resocurces/img/merchandise/service.png",
      information: {}
    }
  },
  created () {
    if (this.$route.params.orderInfo) {
      getSolutionInfoByCartItemData(this.$route.params.orderInfo).then((res) => {
        console.log(res, 'ressssssssssssss')
        this.information = res
        this.setTaxName()
        this.getBoSolutionBasicInfo(res.boSolution)
      })
      console.log(this.$route.params.orderInfo, '未提交')
    } else if (this.$route.params.orderId && this.$route.params.euId) {
      getSolutionInfoByOrderId(this.$route.params.orderId, this.$route.params.euId).then((res) => {
        console.log(res, 'ressssssssssssss')
        this.information = res
        this.setTaxName()
        this.getBoSolutionBasicInfo(res.boSolution)
      })
      console.log(this.$route.params.orderSolution, '已提交')
    } else {
      alert('警告，数据存在错误，请返回后刷新重试或者联系客服！')
    }
    // this.getMeteData()
  },
  methods: {
    specialEuTemplateNo,
    /**
     * @description 获取服务类商品质量承诺与服务说明
     * @param euNo
     */
    getBoSolutionBasicInfo (solution) {
      let that = this
      this.gcapi('loGetBoSolutionBasicInfo', JSON.stringify(solution)).then(function (response) {
        if (response.body.code === 0) {
          that.serviceWorkDaysSolution = JSON.parse(response.body.result)
        } else {
          // $.showPreloader('保存失败！')
        }
        that.show = true
      })
    },
    setTaxName() {
      this.sampleSpecOptArr.some(item => {
        if (item.engName === this.information.tax.dictValue) {
          this.information.sampleSpec = item.chnName
          return true
        }
      })
    }
  },
};
</script>
<style scoped>
.container {
  background: #fff;
}
.bo-logo img {
  height: 48px;
}
.bo-title {
  padding: 0 10px;
  position: relative;
  top: -15px;
}
.bo-title div:first-child {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #424242;
  line-height: 24px;
}
.bo-title div:last-child {
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #5878fa;
  line-height: 14px;
}
.real-price {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #5878fa;
  line-height: 22px;
}
.sale-price {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 17px;
}
.deliver-text {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
}
.deliver-value {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 14px;
  background: #5878fa;
  border-radius: 10px;
  padding: 1px 5px;
}
.advertising-banner {
  background: #fe654d;
  padding: 3px 20px;
  left: 0;
  right: 0;
  position: relative;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 17px;
}
.pop-button span {
  color: #ffffff;
  line-height: 40px;
  vertical-align: middle;
}
.segment-wrap {
  margin: 0 10px;
}
.group-title {
  padding: 0 10px;
  font-family: PingFangSC-Regular;
  font-weight: lighter;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
}
.cell-group-wrap {
  padding: 10px 0;
  background-color: #ffffff;
  border-radius: 10px;
}
.cell-label {
  padding-left: 6px;
  font-family: PingFangSC;
  font-size: 12px;
  color: #424242;
  font-weight: normal;
  line-height: 20px;
}
.cell-content {
  padding-right: 5px;
  text-align: right;
  font-family: PingFangSC;
  font-size: 12px;
  color: #5878fa;
  font-weight: normal;
  line-height: 20px;
  text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
  white-space: nowrap; /*让文字不换行*/
  overflow: hidden; /*超出要隐藏*/
}
input:disabled {
  background-color: #f3f3f3;
  border: none;
  padding: 10px;
  border-radius: 5px;
}
.cancel-default-style /deep/.van-cell {
  padding: 0;
  color: black;
}
.cancel-default-style /deep/.van-field__control {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  color: #5878fa;
  line-height: inherit;
  text-align: left;
  background-color: transparent;
  border: 0;
  resize: none;
}
</style>



// WEBPACK FOOTER //
// BoSolutionDetail.vue?7d33b866